import { CartUpdateEvent } from '@theme/events';

// bfcache restores set event.persisted; pages Chrome will not cache rebuild from disk with persisted false but type back_forward.
const cameBackToPage = (event) =>
  event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';

const lineSignature = (lines) => lines.map(({ key, quantity }) => `${key}:${quantity}`).join('|');

const renderedLines = (component) =>
  lineSignature(
    [...component.querySelectorAll('[ref="cartItemRows[]"]')].map((row) => ({
      key: row.dataset.key,
      quantity: row.querySelector('input[name="updates[]"]')?.value,
    }))
  );

async function syncCartAfterBack() {
  let cart;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    cart = await response.json();
  } catch (_) {
    return;
  }

  const bubble = document.querySelector('cart-icon .cart-bubble__text-count');
  const bubbleStale =
    Boolean(bubble) && cart.item_count < 100 && (parseInt(bubble.textContent ?? '', 10) || 0) !== cart.item_count;
  const wanted = lineSignature(cart.items);
  const listsStale = [...document.querySelectorAll('cart-items-component')].some(
    (component) => renderedLines(component) !== wanted
  );
  if (!bubbleStale && !listsStale) return;

  // The theme's own listeners (header bubble, cart page, drawer, free-ship bar) redraw from this one event.
  // The drawer also slides open on this event name when auto-open is set, so switch that off for the synchronous dispatch.
  const drawers = [...document.querySelectorAll('cart-drawer-component[auto-open]')];
  const autoOpenValues = drawers.map((drawer) => drawer.getAttribute('auto-open'));
  drawers.forEach((drawer) => drawer.removeAttribute('auto-open'));
  try {
    document.dispatchEvent(
      new CartUpdateEvent(cart, 'sr-cart-back-sync', { itemCount: cart.item_count, source: 'sr-cart-back-sync' })
    );
  } finally {
    drawers.forEach((drawer, i) => drawer.setAttribute('auto-open', autoOpenValues[i] ?? ''));
  }
}

window.addEventListener('pageshow', (event) => {
  if (cameBackToPage(event)) syncCartAfterBack();
});
